<template>
  <span>
    <v-btn class="btn-primary" dark @click="modalOpened = true">
      <div class="text-btn">
        {{ $t('Byppay') }}
      </div>
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition"
              content-class="payment-information"
              @click:outside="clickedOutside">
      <template>
        <v-card>
          <div class="pa-5">
            <ListInvoicesForCompensate :original-invoice="chat.invoice" :show-back-button="false" :chat-id="chat._id" @update="nextStep" @save="saveSecondInvoice" />
            <div style="display: flex; flex-direction: row-reverse;">
              <v-btn text color="#FF6961" @click="modalOpened = false">
                {{ $t('Cancel') }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </span>
</template>

<script>
import ListInvoicesForCompensate from "../components/ListInvoicesForCompensate";
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import {User} from "../models/user";
export default {
    name: "BypaymentChatComponent",
    components: {ListInvoicesForCompensate},
    props: {
        createByppass: {type: Boolean, default: false},
        createdInvoice: {type: String, default: undefined},
        chat: {type: Object, required: true}
    },
    data () {
        return {
            modalOpened: false,
            status: "",
            cif: "",
            stripePublicKey: '',
            stripePrivateKey: '',
            publicAddress: '',
            iban: '',
            user: {}
        };
    },
    created () {
        this.iban = this.chat.bankAccount;
        this.user.receiver = this.chat.invoice.receiver;
        this.user.stripePublickey = this.chat.stripePublickey;
        if (this.createByppass && this.createdInvoice && this.createdInvoice !== "") {
            this.saveSecondInvoice({invoice: {_id: this.createdInvoice}});
        }
    },
    methods: {
        saveSecondInvoice (e) {
            const acceptedPaymentMethods = [];
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.CRYPTO);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING);
            this.$emit('byppayAdded');
            ApiRepository.createBypay(e.invoice, this.chat.invoice, false, null, acceptedPaymentMethods).then((ret) => {
                ApiRepository.addBypayToChat(this.chat._id, ret.data.factoring).then(() => {
                    ApiRepository.getFactoringById(ret.data.factoring.toString()).then((res) => {
                        if (res.data.factoring.invoice_payer._id) {
                            ApiRepository.getFilename(res.data.factoring.invoice_payer._id.toString()).then(async (res) => {
                                await ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName);
                            });
                        }
                        ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({message: 'chat.byppay-added', extraMessage: 'chat.byppay-addedExtra',params: {user: (new User(this.$user)).getSingleName(), receiver: this.chat.invoice.receiver.name}}),'chat.byppay-added').then(() => {
                            this.modalOpened = false;
                        });
                        this.$emit('refresh');
                    });
                });
            }).catch(err => {
                console.log(err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
            });
        },
        backStep (e) {
            console.log("back");
            console.log(e);
        },
        nextStep (e) {
            console.log("next");
            console.log(e);
        },
        clickedOutside () {
            this.modalOpened = false;
        },
        openModal () {
            this.modalOpened = true;
        },
        saveForm () {
            this.modalOpened = true;
        },
    }
};
</script>

<style scoped>
.divider{
    padding: 0 0 18px 0;
}
>>> .payment-information {
    align-self: flex-end;
}
>>> .v-text-field--outlined .v-label {
    top: 9px !important;
}
</style>
